import * as React from 'react';
import { Box, Container, Grid, Paper, Typography } from '@mui/material';
import CustomDivider from './CustomDivider';
import NosClients from './NosClients';
import NotreEquipe from './NotreEquipe';
import { withTranslation } from 'react-i18next';

function About({ t }) {
  const expertise = [
    ['About.academie', 'About.academie.description'],
    ['About.conseil', 'About.conseil.description'],
    ['About.RH', 'About.RH.description'],
    ['About.performance', 'About.performance.description'],
  ];
  return (
    <Box sx={{ py: { xs: 7, md: 10 } }}>
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: 780, mb: { xs: 6, md: 9 } }}>
          <Typography sx={{ color: 'primary.main', fontWeight: 800, letterSpacing: '.14em', textTransform: 'uppercase' }}>LCG Solution</Typography>
          <Typography variant="h2" sx={{ mt: 1.5 }}>{t('About.title')}</Typography>
          <CustomDivider sx={{ mt: 2 }} />
          <Typography sx={{ fontSize: '1.15rem', mb: 2 }}>{t('About.description')}</Typography>
          <Typography>{t('About.description1')}</Typography>
        </Box>
        <Grid container spacing={2.5} sx={{ mb: { xs: 8, md: 11 } }}>
          {expertise.map(([title, description]) => (
            <Grid item xs={12} md={6} key={title}>
              <Paper elevation={0} sx={{ height: '100%', p: 3.5, borderRadius: 4 }}>
                <Typography variant="h5" sx={{ color: 'primary.main', mb: 1 }}>{t(title)}</Typography>
                <Typography>{t(description)}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Box component="section" sx={{ mb: { xs: 8, md: 11 } }}>
          <Typography variant="h3">{t('About.clients')}</Typography><CustomDivider sx={{ mt: 2 }} />
          <Paper elevation={0} sx={{ p: { xs: 2, md: 4 }, borderRadius: 5 }}><NosClients /></Paper>
        </Box>
        <Box component="section">
          <Typography variant="h3">{t('About.equipe')}</Typography><CustomDivider sx={{ mt: 2 }} />
          <NotreEquipe />
        </Box>
      </Container>
    </Box>
  );
}

export default withTranslation()(About);
